import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Deal Management (leaf).
export const dealManagement: ContentPage = {
  slug: "salesforce-automation/deal-management",
  template: "hrmsFeature",
  seo: {
    title: "Deal Management Software - Track & Close Deals Faster | GetBiz CRM",
    description:
      "Manage your entire sales pipeline with GetBiz CRM deal management software. Track deals across custom stages, forecast revenue, and close more, faster.",
    keywords: [
      "deal management software",
      "sales pipeline software",
      "deal tracking",
      "pipeline management",
      "opportunity management",
      "sales pipeline management",
      "CRM deal management",
    ],
    ogImage: "/assets/data/seoimages/deal-management.webp",
  },
  leaf: {
    hero: {
      caption: "Deal Management",
      title: "Track Every Deal and Close More, Faster",
      description:
        "Move deals through customizable pipeline stages with full visibility into value, status, and next steps — so nothing stalls and revenue stays predictable.",
      h1: "caption",
    },
    split: {
      title: "A Sales Pipeline You Can Actually See",
      bullets: [
        { title: "Custom Pipelines", description: "Build stages that match exactly how your team sells." },
        { title: "Deal Visibility", description: "See value, owner, age and next step for every deal at a glance." },
        { title: "Revenue Forecasting", description: "Predict revenue with weighted, stage-based forecasting." },
        { title: "Bottleneck Alerts", description: "Spot stalled deals early and act before they slip away." },
      ],
      image: "/assets/images/img/product/crm/cutome-pipeline-image.webp",
      imageAlt: "GetBiz CRM deal management software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Deal Management connects to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Lead Management", href: "/crm-software/salesforce-automation/lead-management/", description: "Capture, score, and route leads that become your next deals.", image: "/assets/images/img/product/crm/lead-managemnet-crm.webp", imageAlt: "CRM lead management" },
      { title: "Contact Management", href: "/crm-software/salesforce-automation/contact-management/", description: "Keep every contact tied to their deals and full history.", image: "/assets/images/img/product/crm/contact-management-image.webp", imageAlt: "CRM contact management" },
      { title: "Account Management", href: "/crm-software/salesforce-automation/account-management/", description: "Roll deals up to the companies and accounts they belong to.", image: "/assets/images/img/product/crm/account-management.webp", imageAlt: "CRM account management" },
      { title: "Workflow Management", href: "/crm-software/salesforce-automation/workflow-management/", description: "Automate stage changes, approvals and tasks as deals progress.", image: "/assets/images/img/product/crm/workflow-image.webp", imageAlt: "CRM workflow management" },
    ],
    testimonials: {
      title: "Sales teams close more with GetBiz CRM",
      description: "See why growing businesses trust GetBiz to run their pipeline.",
    },
    bookDemoTitle: "Get full control of your sales pipeline.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sales-pipeline-management-guide, sales-forecasting-guide",
    metaKey: "deal-management",
  },
  sections: [],
};
